<template>
    <nav class="menu">
        <!-- Dropdown Menu -->
        <transition name="fade-slide">
            <div v-if="isOpen" class="menu-dropdown" ref="menuDropdown">
                <div class="menu-content">
                    <div class="menu-section">
                        <h3>Utforska</h3>
                        <ul>
                            <li v-for="(item, index) in exploreItems" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                    <div class="menu-section">
                        <h3>Toppgenrer</h3>
                        <ul>
                            <li v-for="(item, index) in topGenres" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                </div>
                <div class="menu-footer">
                    <b-button variant="success" @click="closeMenu">Klar</b-button>
                </div>
            </div>
        </transition>
    </nav>
</template>

<script>
// import SearchFilter from './SearchFilter';
export default {
    name: "FilterMenu",
    components: {
        // SearchFilter
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            // filter: new SearchFilter(),
            // errors: null,
        };
    },
    methods: {
        closeMenu() {
            this.$emit("close"); // Notify parent to close the menu
        },
    },
};
</script>

<style scoped>
/* Menu Styling */
.menu {
    position: relative;
    display: inline-block;
}

.menu-header {
    background-color: transparent;
    color: #fff;
    padding: 10px 15px;
    border-radius: 4px;
}

.menu-button {
    background: none;
    border: none;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.menu-button span {
    margin-left: 5px;
    transition: transform 0.3s ease;
}

.rotate-icon {
    position: relative;
    top: 2px;
    transform: rotate(222deg) !important;
}

.normal-icon {
    position: relative;
    bottom: 2px;
    transform: rotate(45deg);
}

.menu-dropdown {
    background: #15244d;
}

/* Dropdown Styling */
.menu-dropdown {
    position: absolute;
    top: 100%;
    /* Position directly below the parent */
    left: 0;
    background: #15244d;
    color: #fff;
    width: 23rem;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    /* Stack content vertically */
    justify-content: space-between;
    /* Space between content and footer */
    padding: 10px;
    z-index: 1000;
    min-height: 15rem;
    /* Ensures enough space for the footer */
}

.menu-content {
    flex: 1;
    /* Allows the content to grow and take up available space */
    display: flex;
    justify-content: space-between;
}

.menu-footer {
    display: flex;
    justify-content: center;
    padding-top: 10px;
    border-top: 1px solid #444;
    /* Optional: visually separate the footer */
}

.menu-section {
    width: 50%;
}

.menu-section h3 {
    font-size: 14px;
    margin-bottom: 5px;
    color: #bbb;
}

.menu-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-section li {
    font-size: 14px;
    padding: 5px 0;
    cursor: pointer;
    transition: color 0.2s;
}

.menu-section li:hover {
    color: #f1c40f;
}

.show-all {
    margin-top: 10px;
    background-color: #11264e;
    color: #fff;
    border: none;
    padding: 8px 0;
    width: 100%;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    transition: background 0.3s;
}

.show-all:hover {
    background-color: #0a1d36;
}

.circle {
    width: 20px;
    height: 20px;
    background-color: #15244d;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    margin-top: 2px;
}

.arrow-down {
    width: 7px;
    height: 7px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
}

/* Fade and Slide Transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
    /* Slide in from slightly above */
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    transform: translateY(0);
}
</style>
